// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".categories-list ul{padding:0;color:inherit;display:flex;flex-wrap:wrap}.categories-list ul li{list-style:none;margin:1px}.categories-list ul li a{padding:0.5rem}\n", ""]);
// Exports
module.exports = exports;
